import { Component, Input, OnInit } from '@angular/core';
import { DateTime } from 'luxon';
import { trackByRoute } from '../../utils/track-by';
import { LayoutService } from '../../services/layout.service';
import { NavigationService } from '../../services/navigation.service';
import { ChangeDetectorRef } from '@angular/core';
import { HomeService } from 'src/@vex/services/homeService/home.service';
import moment from 'moment-timezone';

@Component({
  selector: 'vex-quickpanel',
  templateUrl: './quickpanel.component.html',
  styleUrls: ['./quickpanel.component.scss'],
})
export class QuickpanelComponent implements OnInit {

  date = DateTime.local().toFormat('DD');
  dayName = DateTime.local().toFormat('EEEE');

  @Input() collapsed: boolean;
  collapsedOpen$ = this.layoutService.sidenavCollapsedOpen$;
  ScheduleData: any = [];

  constructor(
    private layoutService: LayoutService,
    private navigationService: NavigationService,
    private cd: ChangeDetectorRef,
    private _homeService: HomeService
  ) { }
  //items = this.navigationService.items;
  trackByRoute = trackByRoute;
  setStep(index: number) {
    this.step = index;
  }
  step = 0;

  ngOnInit() {
    this.getScheduleData();
  }

  getScheduleData() {
    this._homeService.getScheduleData().subscribe((homeScheduleData) => {
      this.ScheduleData = homeScheduleData['data'] ? homeScheduleData['data'] : [];
      // this.ScheduleData.forEach((data) => {
      //   this.date = moment(data.start_date).format('MMM d, y');
      // });

      this.cd.detectChanges();
    });
  }
}
